import * as React from 'react';
import { List } from '@mui/material';
import InnerSectionComponent from './InnerSection';
import { ConfigureSectionDto } from './AccordionContainer';
import ListItemComponent, { ConfigurableItemDto } from './ListItem';

interface ListContainerProps {
    parentPanel: string;
    configurableItems: ConfigurableItemDto[];
    innerSections: ConfigureSectionDto[];
    expandedPanels: string[];
    handleChange: (isExpanded: boolean, panel: string) => void;
}

const ListContainer = (props: ListContainerProps) => {
    const { parentPanel, configurableItems, innerSections, expandedPanels, handleChange } = props;

    return (
        <List>
            {configurableItems.map((item: ConfigurableItemDto, index: number) => (
                <ListItemComponent key={index} dto={item} />
            ))}
            {innerSections.map((item: ConfigureSectionDto, index: number) => (
                <InnerSectionComponent
                    key={index}
                    dto={item}
                    parentPanel={parentPanel}
                    isExpanded={
                        expandedPanels instanceof Array
                            ? expandedPanels.includes(`${parentPanel}-${item.name}`)
                            : false
                    }
                    handleChange={handleChange}
                />
            ))}
        </List>
    );
};

export default ListContainer;
